import React, { useState, useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_CRM_URL, API_BASE_URL } from "../../Config/Config";
import CRMLOGO from "../../../Assets/iBizAccounts.png";
import { Spin } from "antd";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(true); // ← Start with true
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({ username: "", password: "" });

  // useEffect(() => {
  //   const token = localStorage.getItem("authToken")
  //   const superId = localStorage.getItem("superId");

  //   if (token && superId) {
  //     navigate("/profile")
  //   }
  // }, [navigate]);

  const [rememberMe, setRememberMe] = useState(false);


  useLayoutEffect(() => {
    const checkLoginStatus = async () => {
      try {
   
        await new Promise((resolve) => setTimeout(resolve, 100));

        const localData = localStorage.getItem("MisUserDetails");


        if (localData ) {
          let user;
          try {
            user = localData && JSON.parse(localData);
          } catch (parseError) {
            console.error("Corrupted user data:", parseError);
            localStorage.removeItem("MisUserDetails");
            sessionStorage.removeItem("MisUserDetails");
            throw parseError;
          }

          if (user && user.RoleId) {
            navigate("/dashboard", { replace: true });
            return;
          }
        }

        // No valid user → show login form
        setLoading(false);
      } catch (error) {
        console.error("Login check failed:", error);
        setLoading(false);
      }
    };

    checkLoginStatus();
  }, [navigate]); // Runs only once on mount

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${API_BASE_URL}Auth/SignIn`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Name: formData.username,
          Password: formData.password,
        }),
      });

      const data = await response.json();

      if (data.Status && data.ResultData && data.ResultData.length > 0) {
        const user = data.ResultData[0];

        if (rememberMe) {
          localStorage.setItem("MisUserDetails", JSON.stringify(user));
        } else {
          sessionStorage.setItem("MisUserDetails", JSON.stringify(user));
        }

        navigate("/dashboard", { replace: true });
      } else {
        setError("*Invalid Credentials..!");
        setLoading(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      setError("*An error occurred. Please try again.");
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
          }}
        >
          <Spin size="large" tip="Checking login status..." />
        </div>
      )}

      {/* LOGIN FORM (ONLY SHOWS AFTER LOADER) */}
      {!loading && (
        <div className="main-wrapper">
          <div className="account-content">
            <div className="login-wrapper bg-img">
              <div className="login-content">
                <form onSubmit={handleSubmit}>
                  <div className="login-userset">
                    <div className="login-logo logo-normal">
                      <img src={CRMLOGO} alt="img" />
                    </div>
                    <a href="index.html" className="login-logo logo-white">
                      <img src="assets/img/logo-white.png" alt="" />
                    </a>
                    <div className="login-userheading">
                      <h3>Sign In</h3>
                      <h4></h4>
                    </div>
                    <div className="form-login mb-3">
                      <label className="form-label">Username</label>
                      <div className="form-addons">
                        <input
                          type="text"
                          className="form-control"
                          name="username"
                          placeholder="Enter Username"
                          value={formData.username}
                          onChange={handleChange}
                          required
                        />
                        <img src="assets/img/icons/mail.svg" alt="img" />
                      </div>
                    </div>
                    <div className="form-login mb-3">
                      <label className="form-label">Password</label>
                      <div className="pass-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="pass-input form-control"
                          placeholder="Enter password"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          onKeyDown={handleKeyDown}
                          required
                        />
                        <span
                          className={`fas toggle-password ${
                            showPassword ? "fa-eye" : "fa-eye-slash"
                          }`}
                          onClick={togglePasswordVisibility}
                        ></span>
                      </div>
                    </div>
                    <div className="form-login authentication-check">
                      <div className="row">
                        <div className="col-12 d-flex align-items-center justify-content-between">
                          <div className="custom-control custom-checkbox">
                            <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                              <input
                                type="checkbox"
                                checked={rememberMe}
                                onChange={() => {
                                  setRememberMe((prevState) => !prevState);
                                }}
                                className="form-control"
                              />
                              <span className="checkmarks"></span>Remember me
                            </label>
                          </div>

                          <div className="text-end">
                            <a className="forgot-link">Forgot Password?</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-login">
                      <button
                        type="submit"
                        className="btn btn-login"
                        disabled={loading}
                        style={{
                          backgroundColor: "#0f1545",
                          borderColor: "#0f1545",
                        }}
                      >
                        {loading ? "Signing in..." : "Sign In"}
                      </button>
                    </div>
                    <div className="signinform">
                      <h4>
                        New on our platform?
                        <a className="hover-a"> Create an account</a>
                      </h4>
                    </div>
                  </div>
                  {error && <div className="alert alert-danger">{error}</div>}
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
